const socialUrl = {
  email: 'mailto:praveenanand333@gmail.com',
  linkedin: 'https://www.linkedin.com/in/praveenveerachamy/',
  github: 'https://github.com/Praveenanand333',
  leetcode: 'https://leetcode.com/u/praveenanand333/',
};

export default socialUrl;
